/**
 * 入口文件：发布、部署 时使用
 */

import { start } from './index';
start();